import { type Ref, computed, unref, useStore } from "@nuxtjs/composition-api";

import { getLikesStore } from "@/store/likes";

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useLike
 * @param    {Ref<string> | string} ltkId
 * @desc     A composable that returns a like for an LTK from the likes store
 *
 * @summary  Composable used to retrieve a like for an LTK.
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */
export const useLike = (ltkId: Ref<string> | string) => {
  const store = useStore();

  const like = computed(() => getLikesStore(store).likes[unref(ltkId)]);

  return { like };
};
